/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * LiveIcon - Auto-generated from icon.js
 */
export const LiveIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 6H17C18.6569 6 20 7.34315 20 9V16C20 17.6569 18.6569 19 17 19H7C5.34315 19 4 17.6569 4 16V9C4 7.34315 5.34315 6 7 6ZM3 9C3 6.79086 4.79086 5 7 5H17C19.2091 5 21 6.79086 21 9V16C21 18.2091 19.2091 20 17 20H7C4.79086 20 3 18.2091 3 16V9ZM8.15114 15H5V10H6.041V14.1622H8.15114V15ZM10.1005 15H9.05954V10H10.1005V15ZM12.2956 15H13.5336L15.1303 10H14.0752L13.3999 12.4324C13.3164 12.7187 13.244 12.9906 13.1713 13.2638L13.1713 13.2639L13.1713 13.2639L13.1713 13.2639C13.1033 13.5195 13.035 13.7763 12.9568 14.0473H12.9216C12.8323 13.7504 12.7607 13.4706 12.689 13.1907L12.689 13.1907C12.6254 12.9419 12.5617 12.6932 12.4856 12.4324L11.7962 10H10.706L12.2956 15ZM19 15H15.7293V10H18.9226V10.8311H16.7703V11.9865H18.5991V12.8243H16.7703V14.1622H19V15Z"
			fill="current"
		/>
	</svg>
);

export default LiveIcon;
